import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW9010Model } from "../kymw9010.model";

/**
 * 関連会社ユーザ情報を取得する。
 *
 * @export API通信成功時の処理
 * @class GetAssociatedCompanyListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAssociatedCompanyListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9010Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAssociatedCompanyList
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        getAssociatedCompanyList: {
          condition: {
            AssociatedCompanyType: this.model.associatedCompanyType,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9010Model} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetAssociatedCompanyListService
   */
  execute(model: KYMW9010Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getAssociatedCompanyList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAssociatedCompanyList
   */
  success(data: any) {
    this.model.updateAssociatedCompanyList(data);
    if ( this.successFunc !== null ) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetCommonSettingService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
    this.model.kymw9010Component.onClickClose();
  }

}
